import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { cancelBatchAction } from '../../../actions/studio';
import { Props } from './MobileBatchActionWrapper';
import { AppState } from '../../../types/store';
import { getSelectedRowCount } from '../../../selectors/studio';

export type StateProps = Pick<Props, 'selectedCount'>;
export type DispatchProps = Pick<Props, 'onCancel'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  selectedCount: getSelectedRowCount(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  onCancel: () => dispatch(cancelBatchAction()),
});

export default connect(mapStateToProps, mapDispatchToProps);
